<template>
    <b-navbar toggleable type="dark" variant="dark">
        
            <b-navbar-toggle target="navbar-toggle-collapse">
                <template v-slot:default="{ expanded }">
                 
                    <span>Menú</span>
                </template>
            </b-navbar-toggle>

             <b-collapse id="navbar-toggle-collapse" is-nav>
                <b-navbar-nav >
                <Vendedoritems/>
              
                <RCIitems/>
                <Preprensaitems/>
                <Ingenieriaitems/>
                <Bitacoraitems/>
                <Reportesitems/>
                <Googleitems/>
                <Ticketsitems/>
                <TicketsMantenimiento/>
                <Adminitems/>
                
                <b-nav-item @click="_logout"> Cerrar sesión </b-nav-item>    
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>
</template>

<script>
    import {mapMutations,mapState,mapActions} from 'vuex'
    import Adminitems from '@/components/navigations/Admin'
    import Vendedoritems from '@/components/navigations/Vendedor'
    import Preprensaitems from '@/components/navigations/Preprensa'
    import Ingenieriaitems from '@/components/navigations/Ingenieria'
    import Bitacoraitems from '@/components/navigations/Bitacora'
    import Googleitems from '@/components/navigations/Google'
    import RCIitems from '@/components/navigations/DatosRCI'
    import Reportesitems from '@/components/navigations/Reportes'
    import Ticketsitems from '@/components/navigations/Tickets'
    import TicketsMantenimiento from '@/components/navigations/TicketsMantenimiento'
   
    export default {
        components:{
           Vendedoritems, Adminitems, Preprensaitems, Ingenieriaitems, Bitacoraitems, Googleitems, RCIitems, Reportesitems, Ticketsitems, TicketsMantenimiento
        },
        methods:{
            ...mapMutations('login',['logout']),
            _logout(){
                this.logout()
                this.$router.push('/login')
            },
        }
    }
</script>

<style lang="scss" scoped>

</style>